import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useEffect } from 'react';
import { monitorMeetingPreviewRender } from '../../api/hubspotPluginApi';
import MeetingController from './MeetingController';
import MeetingsContextWrapper from './MeetingsContext';
import PreviewMeeting from './PreviewMeeting';
export default function MeetingEdit({ attributes: { url }, isSelected, setAttributes, preview = true, origin = 'gutenberg', }) {
    const handleChange = (newUrl) => {
        setAttributes({
            url: newUrl,
        });
    };
    useEffect(() => {
        monitorMeetingPreviewRender(origin);
    }, [origin]);
    return (_jsxs(Fragment, { children: [(isSelected || !url) && (_jsx(MeetingsContextWrapper, { url: url, children: _jsx(MeetingController, { handleChange: handleChange }) })), preview && url && _jsx(PreviewMeeting, { url: url })] }));
}
